import { TypeInitProps, TypeRequest } from '../../types';
import { encryptParams } from '../../utils/index';
import { APP_URL } from '../../utils/urls';
export default class VerifyAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} mobile - mobile to be verified
   * @return {Promise} - send result
   */
  notLoginSendCode = (params: { mobile: string; extra_params?: object }) => {
    const { mobile, extra_params = {} } = params;
    const data = encryptParams({ mobile, type: 34, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return this.request({
      url: APP_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} mobile - mobile to be verified
   * @param {string} code - the captcha
   * @return {Promise} - verify result
   */
  notLoginValidateMobile = (params: {
    mobile: string;
    code: string;
    extra_params?: object;
  }) => {
    const { mobile, code, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, type: 34, ...extra_params }, [
      'mobile',
      'code',
      'type',
    ]);
    return this.request({
      url: APP_URL.CHECK_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };
}
